function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.2001 1.6001C6.77575 1.6001 6.36878 1.76867 6.06873 2.06873C5.76867 2.36878 5.6001 2.77575 5.6001 3.2001V9.6001C5.6001 10.0244 5.76867 10.4314 6.06873 10.7315C6.36878 11.0315 6.77575 11.2001 7.2001 11.2001H12.0001C12.4244 11.2001 12.8314 11.0315 13.1315 10.7315C13.4315 10.4314 13.6001 10.0244 13.6001 9.6001V5.1313C13.6 4.70699 13.4314 4.30009 13.1313 4.0001L11.2001 2.0689C10.9001 1.76882 10.4932 1.60019 10.0689 1.6001H7.2001Z",
  fill: "#FB5806"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.3999 6.40005C2.3999 5.9757 2.56847 5.56874 2.86853 5.26868C3.16859 4.96862 3.57556 4.80005 3.9999 4.80005V12.8H10.3999C10.3999 13.2244 10.2313 13.6314 9.93127 13.9314C9.63121 14.2315 9.22425 14.4 8.7999 14.4H3.9999C3.57556 14.4 3.16859 14.2315 2.86853 13.9314C2.56847 13.6314 2.3999 13.2244 2.3999 12.8V6.40005Z",
  fill: "#FB5806"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fc48a164.svg";
export { ForwardRef as ReactComponent };